
import { filterMatchesByOddsRange } from './helpers';

/**
 * Calculate profit/loss for backing a specific odds range
 */
export const calculateProfitForOddsRange = (matches: any[], range: { min: number, max: number }, oddsType: 'home' | 'away'): number => {
  // Only use B365 odds fields instead of multiple bookmakers
  const oddsField = oddsType === 'home' ? 'B365H' : 'B365A';
  
  let profitLoss = 0;
  
  matches.forEach(match => {
    // Parse odds value, ensuring we handle string or number inputs
    const oddsValue = typeof match[oddsField] === 'string' ? parseFloat(match[oddsField]) : match[oddsField];
    
    // Only process matches where B365 odds are within the specified range
    if (!isNaN(oddsValue) && oddsValue >= range.min && oddsValue <= range.max) {
      const isHomeTeamOdds = oddsType === 'home';
      
      if (isHomeTeamOdds && match.FTR === 'H') {
        // Home team won - we win (odds-1)
        profitLoss += (oddsValue - 1);
      } else if (!isHomeTeamOdds && match.FTR === 'A') {
        // Away team won - we win (odds-1)
        profitLoss += (oddsValue - 1);
      } else {
        // Lost bet - lose 1 unit
        profitLoss -= 1;
      }
    }
  });
  
  return profitLoss;
};

/**
 * Calculate profit/loss from laying the odds
 */
export const calculateLayProfitForOddsRange = (matches: any[], range: { min: number, max: number }, oddsType: 'home' | 'away'): number => {
  const oddsField = oddsType === 'home' ? 'B365H' : 'B365A';
  const layMarkup = 0.1; // The markup added to the back odds to get the lay odds
  
  let profitLoss = 0;
  
  matches.forEach(match => {
    // Parse odds value, ensuring we handle string or number inputs
    const oddsValue = typeof match[oddsField] === 'string' ? parseFloat(match[oddsField]) : match[oddsField];
    
    // Only process matches where B365 odds are within the specified range
    if (!isNaN(oddsValue) && oddsValue >= range.min && oddsValue <= range.max) {
      const isHomeTeamOdds = oddsType === 'home';
      const layOdds = oddsValue + layMarkup;
      
      if ((isHomeTeamOdds && match.FTR === 'H') || (!isHomeTeamOdds && match.FTR === 'A')) {
        // Team won - laying the odds loses: (layOdds * 1) - 1
        profitLoss -= (layOdds - 1);
      } else {
        // Team did not win - laying the odds wins: +1
        profitLoss += 1;
      }
    }
  });
  
  return profitLoss;
};
